import { makeStyles } from '@material-ui/core/styles';

const useJobsStyles = makeStyles({
  heading:{
    //textTransform: 'capitalize',
  }
});

export { useJobsStyles }